import React from "react";

const Button = ({
  text,
  type = "primary",
  fullWidth = false,
  onClick,
  className,
  icon,
  disabled,
}) => {
  return (
    <button
      className={`button button-${type} ${fullWidth ? "full-width" : ""} ${
        className || ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
      {text}
    </button>
  );
};

export default Button;
